import { ReactNode } from 'react';
import { To, useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

export default function CardHeader(props: {
  title: string;
  withBackButton?: boolean;
  handleBackButtonClick?: () => void;
  onCrossButton?: () => void;
  backTarget?: string | To | number;
  hideTitle?: boolean;
  children?: ReactNode;
  className?: string;
}) {
  const navigate = useNavigate();

  return (
    <div className={classNames('card-header px-2 py-4 md:px-4', props.className)}>
      <div className="sm:flex sm:items-center">
        {!props.hideTitle ? (
          <div className="flex items-center sm:flex-auto">
            {props.withBackButton && (
              <button
                data-testid="back-button"
                onClick={() => {
                  if (props.handleBackButtonClick) {
                    props.handleBackButtonClick();
                    return;
                  }

                  if (typeof props.backTarget === 'number') {
                    navigate(props.backTarget);
                  } else {
                    navigate(props.backTarget ?? '..');
                  }
                }}
              >
                <ChevronLeftIcon className="mr-2 w-6" />
              </button>
            )}
            <h1
              className={classNames('text-2xl font-medium leading-6 text-gray-900', {
                'ml-1': !props.withBackButton,
              })}
            >
              {props.title}
            </h1>

            {props.onCrossButton && (
              <>
                <div className="flex-1" />
                <XMarkIcon
                  onClick={() => {
                    props.onCrossButton?.();
                  }}
                  className="h-8 w-8"
                />
              </>
            )}
          </div>
        ) : (
          <div className="flex-1" />
        )}

        {props.children && (
          <div
            className={classNames('xs:flex-none flex flex-wrap items-center gap-4 sm:ml-16 sm:mt-0', {
              'mt-4': !props.hideTitle,
            })}
          >
            {props.children}
          </div>
        )}
      </div>
    </div>
  );
}
